import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import propTypes from "prop-types"
import configs from "../../configs"
import { createPlan } from "../../services/plans"
import { signOut } from "../../services/authentication"
import "./styles.scss"

import Logo from "../Logo"
import Nav from "../Nav"
import UserButton from "./components/UserButton"
import UserDropMenu from "./components/UserDropMenu"

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuIsOpen: false
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  onRouteChanged = () => {
    this.setState({ menuIsOpen: false })
  }

  handleClickOutside = event => {
    const { menuIsOpen } = this.state
    if (this.userMenu && !this.userMenu.contains(event.target) && menuIsOpen) {
      this.setState({ menuIsOpen: false })
    }
  }

  toggleUserMenu = e => {
    e.preventDefault()
    const { menuIsOpen } = this.state

    this.setState({
      menuIsOpen: !menuIsOpen
    })
  }

  handleOnSupportTeam = () => {
    const { onCreatePlan, store, history } = this.props
    const planIsExist = !!store.planId

    if (planIsExist) {
      history.push("/pre-plan/support-team")
    } else {
      onCreatePlan(store.user.token).then(() => {
        history.push("/pre-plan/support-team")
      })
    }
  }

  render() {
    const { theme, store, hideNotifications, onSignOut } = this.props
    const { menuIsOpen } = this.state
    let color
    let navList

    if (store.user.list_role) {
      if (store.user.list_role.includes(configs.roles.Participant)) {
        navList = configs.navigation_participant
      } else if (store.user.list_role.includes(configs.roles.Guardian)) {
        navList = configs.navigation_guardian
      }
    }

    if (store.notifications.length && !hideNotifications) {
      color = "white"
    } else if (theme === "light") {
      color = "white"
    } else {
      color = "black"
    }

    return (
      <header
        className={`header header--${theme} header--notifications-${
          !!store.notifications.length && !hideNotifications ? "open" : ""
        }`}
      >
        <div className="container">
          <div className="row">
            <div className="col">
              <Logo color={color} href="/" title="Resanec" />

              <Logo color={color} href="/" title="Resanec" mobile />
            </div>

            <div className="col col-nav d-flex justify-content-center">
              <Nav
                navigation={navList}
                planIsExist={!!store.planId}
                isLogged={store.isLogged}
                onSignOut={onSignOut}
                className={`${
                  !!store.notifications.length && !hideNotifications
                    ? "nav--light"
                    : `nav--${theme}`
                } `}
              />
            </div>

            <div className="col d-flex justify-content-end">
              {store.isLogged && (
                <div
                  className={`user-menu ${
                    !!store.notifications.length && !hideNotifications
                      ? "user-menu--light"
                      : `user-menu--${theme}`
                  } `}
                  ref={node => {
                    this.userMenu = node
                  }}
                >
                  {!!store.notifications.length && !hideNotifications && (
                    <div className="user-menu_notifications-amount">
                      {store.notifications.length}
                    </div>
                  )}
                  <UserButton
                    name={store.user.name}
                    onClick={this.toggleUserMenu}
                  />
                  <UserDropMenu
                    navigation={configs.user_navigation}
                    onSupportTeam={this.handleOnSupportTeam}
                    onSignOut={onSignOut}
                    isOpen={menuIsOpen}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  theme: propTypes.string.isRequired,
  notifications: propTypes.number,
  onCreatePlan: propTypes.func.isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  hideNotifications: propTypes.bool,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }).isRequired,
    notifications: propTypes.arrayOf(
      propTypes.shape({
        id: propTypes.oneOfType([propTypes.string, propTypes.number]),
        description: propTypes.string,
        href: propTypes.string
      })
    ),
    planId: propTypes.string,
    isLogged: propTypes.bool.isRequired
  }).isRequired,
  onSignOut: propTypes.func.isRequired
}

Header.defaultProps = {
  notifications: 0,
  hideNotifications: false
}

const mapStateToProps = ({
  AuthenticationReducer,
  NotificationsReducer,
  PlansReducer
}) => ({
  store: {
    isLogged: AuthenticationReducer.isLogged,
    user: AuthenticationReducer.user,
    notifications: NotificationsReducer.unread,
    planId: PlansReducer.id
  }
})

const mapDispatchToProps = dispatch => ({
  onCreatePlan: token => dispatch(createPlan(token)),
  onSignOut: () => dispatch(signOut())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
